import React, { Component } from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_PEDIDO_CAMIONES_EN_PLAYA_INSATISFECHO } from '../../../../config/tables'

export class TablaPedidoCamionesEnPlayaInsatisfechoView extends Component {
  render () {
    return (
      <MuiTable id={TABLA_PEDIDO_CAMIONES_EN_PLAYA_INSATISFECHO} />
    )
  }
}
